import { lazy } from 'react';

const SellerCategoryRoutes = [
  {
    path: 'seller/categories',
    component: lazy(() => import('views/seller-views/categories')),
  },
  {
    path: 'seller/category/add',
    component: lazy(() => import('views/seller-views/categories/category-add')),
  },
  {
    path: 'seller/category/:uuid',
    component: lazy(
      () => import('views/seller-views/categories/category-edit'),
    ),
  },
  {
    path: 'seller/category-clone/:uuid',
    component: lazy(
      () => import('views/seller-views/categories/category-clone'),
    ),
  },
  {
    path: 'seller/categories/import',
    component: lazy(
      () => import('views/seller-views/categories/category-import'),
    ),
  },
];

export default SellerCategoryRoutes;
